import HamburgerMenu from '../../src/legacy/HamburgerMenu.tsx';
export default HamburgerMenu;
